import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getRegisterDataForRegimeTable = api(({ regimeId, skip = 0, take = 10, orderStmt = ["name"] } = {}) =>
    query(
        gql`
            query GetRegisterDataForRegimeTable(
                $regimeId: String!
                $searchTerm: String
                $filterStmt: [String]
                $skip: Int
                $take: Int
                $orderStmt: [String]
            ) {
                getRegisterDataForRegimeTable(
                    regimeId: $regimeId
                    searchTerm: $searchTerm
                    skip: $skip
                    take: $take
                    orderStmt: $orderStmt
                    filterStmt: $filterStmt
                ) {
                    totalCount
                    pageInfo {
                        endCursor
                        hasNextPage
                        hasPreviousPage
                        startCursor
                    }
                    edges {
                        node {
                            id
                            registerName
                            assetCount
                            modifiedDate
                            modifiedBy
                        }
                        cursor
                    }
                }
            }
        `,
        { regimeId, skip, take, orderStmt },
        { returns: "getRegisterDataForRegimeTable" }
    )
)
